"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ButtonBase_1 = __importDefault(require("@material-ui/core/ButtonBase"));
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var IconButton_1 = require("../IconButton");
var styles_1 = require("../styles");
var styles = function (theme) { return ({
    /* Styles applied to the root element. */
    root: {
        display: 'flex',
        minHeight: 8 * 5,
        transition: theme.transitions.create(['background-color'], { duration: theme.transitions.duration.shortest }),
        padding: '0 24px 0 24px',
        '&:hover:not($disabled)': {
            cursor: 'pointer',
        },
        '&$expanded': {
            backgroundColor: theme.palette.grey[200],
        },
        '&$focused': {},
        '&$disabled': {
            opacity: 0.38,
        },
    },
    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},
    /* Styles applied to the root and children wrapper elements when focused. */
    focused: {},
    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the children wrapper element. */
    content: {
        display: 'flex',
        flexGrow: 1,
        transition: theme.transitions.create(['margin'], { duration: theme.transitions.duration.shortest }),
        margin: '8px 0',
        '& > :last-child': {
            paddingRight: 32,
        },
        '&$expanded': {
            margin: '8px 0',
        },
    },
    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
        position: 'absolute',
        top: '50%',
        right: 8,
        transform: 'translateY(-50%) rotate(0deg)',
        transition: theme.transitions.create('transform', { duration: theme.transitions.duration.shortest }),
        '&:hover': {
            // Disable the hover effect for the IconButton,
            // because a hover effect should apply to the entire Expand button and
            // not only to the IconButton.
            backgroundColor: 'transparent',
        },
        '&$expanded': {
            transform: 'translateY(-50%) rotate(180deg)',
        },
    },
}); };
var UnstyledCompactAccordionSummary = /** @class */ (function (_super) {
    __extends(UnstyledCompactAccordionSummary, _super);
    function UnstyledCompactAccordionSummary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focused: false,
        };
        _this.handleFocus = function () {
            _this.setState({
                focused: true,
            });
        };
        _this.handleBlur = function () {
            _this.setState({
                focused: false,
            });
        };
        return _this;
    }
    UnstyledCompactAccordionSummary.prototype.render = function () {
        var _a, _b, _c;
        var _this = this;
        var _d = this.props, children = _d.children, classes = _d.classes, className = _d.className, disabled = _d.disabled, expanded = _d.expanded, expandIcon = _d.expandIcon, IconButtonProps = _d.IconButtonProps, onChange = _d.onChange, other = __rest(_d, ["children", "classes", "className", "disabled", "expanded", "expandIcon", "IconButtonProps", "onChange"]);
        var focused = this.state.focused;
        return (react_1.default.createElement(ButtonBase_1.default, __assign({ focusRipple: false, disableRipple: true, disabled: disabled, component: "div", "aria-expanded": expanded, className: (0, clsx_1.default)(classes.root, (_a = {},
                _a[classes.disabled] = disabled,
                _a[classes.expanded] = expanded,
                _a[classes.focused] = focused,
                _a), className) }, other, { onFocusVisible: this.handleFocus, onBlur: this.handleBlur, onClick: function (event) {
                var _a, _b, _c, _d;
                (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, event);
                (_d = (_c = _this.props).onClick) === null || _d === void 0 ? void 0 : _d.call(_c, event);
            } }),
            react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.content, (_b = {},
                    _b[classes.expanded] = expanded,
                    _b)) }, children),
            expandIcon && (react_1.default.createElement(IconButton_1.IconButton, __assign({ disabled: disabled, className: (0, clsx_1.default)(classes.expandIcon, (_c = {},
                    _c[classes.expanded] = expanded,
                    _c)), component: "div", tabIndex: -1, "aria-hidden": "true" }, IconButtonProps), expandIcon))));
    };
    UnstyledCompactAccordionSummary.defaultProps = {
        disabled: false,
    };
    UnstyledCompactAccordionSummary.muiName = 'CompactAccordionSummary';
    return UnstyledCompactAccordionSummary;
}(react_1.Component));
var CompactAccordionSummary = (0, styles_1.withStyles)(styles, { name: 'CompactAccordionSummary' })(UnstyledCompactAccordionSummary);
exports.default = CompactAccordionSummary;
//# sourceMappingURL=CompactAccordionSummary.js.map